import createHydrationWrapper from "../utils/create-hydration-wrapper.mjs";
import useHydrateWhenVisible from "../composables/useHydrateWhenVisible.mjs";
function hydrateWhenVisible(source, observerOpts) {
  return createHydrationWrapper(source, (result) => {
    useHydrateWhenVisible(result, observerOpts);
  });
}
export {
  hydrateWhenVisible as default
};
